<template>
  <div class="m_page_banner">
    <div class="mpb_bg_img">
      <img :src="backgroundImage" alt="" />
    </div>
    <div class="mpb_container">
      <div v-for="slogan in slogans" :key="slogan" class="mpbc_slogan">
        {{ slogan }}
      </div>
      <a v-if="buttonHref" class="m_btn" :href="buttonHref">
        {{ buttonText }}
      </a>
      <div v-else-if="onButtonClick" class="m_btn" @click="onButtonClick">
        {{ buttonText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePageBanner',
  props: {
    backgroundImage: {
      type: String,
      default: '',
    },
    slogans: {
      type: Array,
      default: () => [],
    },
    buttonText: {
      type: String,
      default: '立即咨询',
    },
    buttonHref: {
      type: String,
      default: null,
    },
    onButtonClick: {
      type: Function,
      default: null,
    },
  },
}
</script>

<style lang="scss">
.m_page_banner {
  position: relative;
  height: 164px;
  overflow: hidden;
  .mpb_bg_img,
  .mpb_container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -1px;
    right: -1px;
  }
  .mpb_bg_img {
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .mpb_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 22px;
    color: #fff;
    .mpbc_slogan {
      font-size: 16px;
      line-height: 28px;
    }
  }
}
</style>
